import React, { useEffect, useState, useContext } from 'react';

// EN ESTE COMPONENTE IMPLEMENTAREMOS LA LÓGICA PARA EL CHATBOT, SOLO SE PERMITEN PREGUNTAS ENLATADAS, CON RESPUESTAS PREDEFINIDAS, NO SE PERMITE RESPUESTAS LIBRES, ESTO PARA EVITAR PROBLEMAS DE SEGURIDAD Y CONTROL DE LA INFORMACIÓN. EL CHATBOT SE UTILIZARÁ PARA RESPONDER PREGUNTAS FRECUENTES SOBRE LOS CURSOS, INSCRIPCIONES, CERTIFICADOS, ETC.
import MainCard from 'ui-component/cards/MainCard';
import { Button, Typography, IconButton, Tooltip, FormControl, InputLabel, Select, MenuItem, Switch } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { IconTrash } from '@tabler/icons';
import { Tabla, ModalFormularioV2 } from 'ui-component';
import FormNuevaPregunta from './FormNuevaPregunta';
import LayautContext from 'Context/ContextLayaut';

import ServiciosChatBot from './components/serviciosChatBot';

function ChatBot() {
    const context = useContext(LayautContext);
    const serviciosChatBot = ServiciosChatBot();
    const columns = [
        { label: 'Pregunta', name: 'pregunta' },
        { label: 'Respuesta', name: 'respuesta' },
        { label: 'Orden', name: 'orden', hidden: true },
        {
            label: 'Mover',
            name: 'acciones',
            accion: (row, idx, preguntas, moverPregunta) => (
                <>
                    <Tooltip title="Subir">
                        <span>
                            <IconButton size="small" onClick={() => moverPregunta(idx, -1)} disabled={idx === 0}>
                                <ArrowUpward fontSize="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Bajar">
                        <span>
                            <IconButton size="small" onClick={() => moverPregunta(idx, 1)} disabled={idx === preguntas.length - 1}>
                                <ArrowDownward fontSize="inherit" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </>
            ),
            hidden: true
        },
        {
            label: 'VISIBLE EN CHATBOT',
            name: 'estatus',
            filtrar: false,
            type: {
                opcion: 'componente',
                accion: (row) => (
                    <Tooltip title={row.estatus == 1 ? 'Desactivar' : 'Activar'}>
                        <Switch
                            checked={row.estatus == 1}
                            onChange={() => handleToggleEstatus(row.id_pre_res, row.estatus == 1 ? 0 : 1)}
                            color="primary"
                        />
                    </Tooltip>
                )
            }
        },
        {
            label: 'ELIMINAR',
            name: 'estatus2',
            filtrar: false,
            type: {
                opcion: 'componente',
                accion: (row) => (
                    <Tooltip title="Eliminar">
                        <IconButton size="small" onClick={() => handleEliminarPregunta(row.id_pre_res)}>
                            <IconTrash />
                        </IconButton>
                    </Tooltip>
                )
            }
        }
    ];

    const [preguntas, setPreguntas] = useState([]);
    const [filtroEstatus, setFiltroEstatus] = useState('TODO');

    useEffect(() => {
        serviciosChatBot.listaPreguntasBot((res) => {
            setPreguntas(res?.data?.preguntas || []);
        });
    }, []);

    // Abrir modal para nueva pregunta
    const handleAbrirNuevaPregunta = () => {
        context.formulario.abrir({
            open: true,
            titulo: 'Detalle de Asignación',
            propsForm: {
                data: null
            },
            formulario: FormNuevaPregunta,
            aceptar: ({ pregunta, respuesta }) => {
                const nueva = {
                    pregunta,
                    respuesta,
                    orden: preguntas.length + 1,
                    estatus: 'ACTIVO'
                };
                serviciosChatBot.crearPreguntaBot((res) => {
                    if (res?.status == 1) {
                        // Refrescar la lista completa desde el backend para mantener el orden y consistencia
                        serviciosChatBot.listaPreguntasBot((res2) => {
                            setPreguntas(res2?.data?.preguntas || []);
                        });
                    }
                    context.formulario.cerrar();
                }, nueva);
            },
            cancelar: () => context.formulario.cerrar()
        });
    };

    // Abrir modal para editar pregunta
    const handleEditarPregunta = (row) => {
        context.formulario.abrir({
            open: true,
            propsForm: {
                data: row
            },
            formulario: FormNuevaPregunta,
            aceptar: ({ pregunta, respuesta }) => {
                serviciosChatBot.actualizaPreguntaBot(
                    (res) => {
                        if (res?.status == 1) {
                            setPreguntas(preguntas.map((p) => (p.id_pre_res === row.id_pre_res ? { ...p, pregunta, respuesta } : p)));
                        }
                        context.formulario.cerrar();
                    },
                    { id_pre_res: row.id_pre_res, pregunta, respuesta }
                );
            },
            cancelar: () => context.formulario.cerrar()
        });
    };

    const moverPregunta = (idx, dir) => {
        const nuevoOrden = [...preguntas];
        const target = idx + dir;
        if (target < 0 || target >= preguntas.length) return;
        // Intercambiar posiciones
        [nuevoOrden[idx], nuevoOrden[target]] = [nuevoOrden[target], nuevoOrden[idx]];
        // Actualizar el campo orden
        const actualizadas = nuevoOrden.map((p, i) => ({ ...p, orden: i + 1 }));
        setPreguntas(actualizadas);
        // Enviar al backend el nuevo orden
        const ordenPayload = actualizadas.map((p) => ({ id_pre_res: p.id_pre_res, orden: p.orden }));
        serviciosChatBot.ordenarPreguntaBot(
            (res) => {
                // Opcional: refrescar desde backend si es necesario
                if (res?.status !== 1) {
                    // Manejar error si falla el guardado
                }
            },
            { preguntas: ordenPayload }
        );
    };

    // Filtrar preguntas según estatus
    const preguntasFiltradas = filtroEstatus === 'TODO' ? preguntas : preguntas.filter((p) => p.estatus == filtroEstatus);

    // Render personalizado para la columna de acciones
    const renderRows = preguntasFiltradas.map((row, idx) => ({
        ...row,
        acciones: (
            <>
                {columns.find((c) => c.name === 'acciones')?.accion(row, idx, preguntasFiltradas, moverPregunta)}
                <Tooltip title="Editar">
                    <IconButton size="small" onClick={() => handleEditarPregunta(row)}>
                        <i className="fas fa-edit" />
                    </IconButton>
                </Tooltip>
            </>
        )
        // No sobreescribas 'estatus', deja el valor real para que el switch se actualice correctamente
    }));

    const handleToggleEstatus = (id, nuevoEstatus) => {
        // AHORA CONECTAMO CON EL SERVICIO PARA CAMBIAR EL ESTATUS EN EL BACKEND ANTES DE ACTUALIZAR EL ESTADO LOCAL
        serviciosChatBot.cambiarEstatusPreguntaBot(
            (res) => {
                if (res?.status == 1) {
                    setPreguntas(preguntas.map((p) => (p.id_pre_res === id ? { ...p, estatus: nuevoEstatus } : p)));
                } else {
                    // Manejar error al cambiar estatus
                }
            },
            { id_pre_res: id, estatus: nuevoEstatus }
        );
    };

    const handleEliminarPregunta = (id) => {
        context.modal.confirmar({
            open: true,
            title: 'ELIMINAR PREGUNTA',
            text: '¿Está seguro de eliminar esta pregunta?, no podrá ser recuperada.',
            aceptar: () => {
                serviciosChatBot.cambiarEstatusPreguntaBot(
                    (res) => {
                        if (res?.status == 1) {
                            setPreguntas(preguntas.filter((p) => p.id_pre_res !== id));
                        }
                        context.modal.cerrar();
                    },
                    { id_pre_res: id, estatus: -1 }
                );
            },
            cancelar: () => context.modal.cerrar()
        });
    };

    const accionesTabla = [
        {
            label: 'Filtrar estatus',
            component: () => (
                <FormControl size="small" style={{ minWidth: 160, marginRight: 16 }}>
                    <InputLabel id="filtro-estatus-label">Estatus</InputLabel>
                    <Select
                        labelId="filtro-estatus-label"
                        value={filtroEstatus}
                        label="Estatus"
                        onChange={(e) => setFiltroEstatus(e.target.value)}
                    >
                        <MenuItem value="TODO">TODO</MenuItem>
                        <MenuItem value={1}>ACTIVO</MenuItem>
                        <MenuItem value={0}>INACTIVO</MenuItem>
                    </Select>
                </FormControl>
            ),
            disabled: false
        },
        {
            label: 'Nueva pregunta',
            component: () => (
                <Button variant="contained" color="primary" onClick={handleAbrirNuevaPregunta}>
                    Nueva pregunta
                </Button>
            ),
            disabled: false
        }
    ];

    const accionesFila = [
        // {
        //     label: 'Editar',
        //     onClick: (row) => {
        //         setEditPregunta(row);
        //         setOpenNuevaPregunta(true);
        //     },
        //     icon: (
        //         <Tooltip title="Editar">
        //             <IconButton size="small">
        //                 <i className="fas fa-edit" />
        //             </IconButton>
        //         </Tooltip>
        //     ),
        //     enabled: () => true
        // }
        // El switch ya está en la columna, no es necesario en accionesFila
    ];

    return (
        <MainCard title={'CHAT BOT - PREGUNTAS FRECUENTES.'}>
            <Tabla columns={columns} rows={renderRows} columnKey="id_pre_res" accionesTabla={accionesTabla} accionesFila={accionesFila} />
        </MainCard>
    );
}

export default ChatBot;
